import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

import shoppingImage from '../../assets_user/img/shopping-cart.png';
import orderImage from '../../assets_user/img/order-image.png';
import heartImage from '../../assets_user/img/love-image.png'

import { useBlogContext } from '../../../fetchdata/BlogContext';
import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
const Account = () => {
 
  const [user, setUser] = useState(true); // State to manage which form to display


  useEffect(() => {

  const decryptdatajson = getDecryptData();
  setUser(decryptdatajson);
}, []);


  return (
    <>

      <Header />

      <Helmet>
        <title> Account | {window.location.hostname}</title>

      </Helmet>
 
        <div className="user-dasboard whitesmoke" >

          <div className="container pt-4">
            <div className="row pb-4">

              <AccountSidebar />

              <div className="col-lg-9 my-lg-0 my-1">
                <div id="main-content" className="bg-white border">
                  <div className="d-flex flex-column mb-4">
                    <div className="h5">Hello User

                    </div>
                    {/* <div>Logged in as: someone@gmail.com</div> */}
                  </div>
 
  <div className="row g-4 justify-content-center">

    {/* My Account */}
    <div className="col-lg-4 col-md-6">
      <Link to="/account" className="text-decoration-none">
        <div className="card border-0 shadow-lg h-100 rounded-4 p-4 text-center">
          <div className="bg-info bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3 mx-auto"
               style={{ width: 70, height: 70 }}>
            <i className="ri-user-3-line fs-2 text-primary"></i>
          </div>
          <h5 className="fw-bold text-dark mb-1">My Account</h5>
          <p className="text-muted small mb-0">View account overview & details</p>
        </div>
      </Link>
    </div>

    {/* All Bookings */}
    <div className="col-lg-4 col-md-6">
      <Link to="/account/all-order" className="text-decoration-none">
        <div className="card border-0 shadow-lg h-100 rounded-4 p-4 text-center">
          <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3 mx-auto"
               style={{ width: 70, height: 70 }}>
            <i className="ri-calendar-check-line fs-2 text-success"></i>
          </div>
          <h5 className="fw-bold text-dark mb-1">All Bookings</h5>
          <p className="text-muted small mb-0">Track & manage your bookings</p>
        </div>
      </Link>
    </div>

    {/* My Profile */}
    <div className="col-lg-4 col-md-6">
      <Link to="/account/profile" className="text-decoration-none">
        <div className="card border-0 shadow-lg h-100 rounded-4 p-4 text-center">
          <div className="bg-info bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3 mx-auto"
               style={{ width: 70, height: 70 }}>
            <i className="ri-id-card-line fs-2 text-info"></i>
          </div>
          <h5 className="fw-bold text-dark mb-1">My Profile</h5>
          <p className="text-muted small mb-0">Edit personal information</p>
        </div>
      </Link>
    </div>

    {/* Change Password */}
    <div className="col-lg-4 col-md-6">
      <Link to="/account/password" className="text-decoration-none">
        <div className="card border-0 shadow-lg h-100 rounded-4 p-4 text-center">
          <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3 mx-auto"
               style={{ width: 70, height: 70 }}>
            <i className="ri-lock-password-line fs-2 text-warning"></i>
          </div>
          <h5 className="fw-bold text-dark mb-1">Change Password</h5>
          <p className="text-muted small mb-0">Secure your account access</p>
        </div>
      </Link>
    </div>

    {/* Help & Support */}
    <div className="col-lg-4 col-md-6">
      <Link to="/account/support" className="text-decoration-none">
        <div className="card border-0 shadow-lg h-100 rounded-4 p-4 text-center">
          <div className="bg-danger bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3 mx-auto"
               style={{ width: 70, height: 70 }}>
            <i className="ri-customer-service-2-line fs-2 text-danger"></i>
          </div>
          <h5 className="fw-bold text-dark mb-1">Help & Support</h5>
          <p className="text-muted small mb-0">Get help & contact support</p>
        </div>
      </Link>
    </div>

  </div>
 




                </div>
              </div>
            </div>
          </div>

        </div>
   

      <Footer />


    </>
  )
}

export default Account